import { render, staticRenderFns } from "./ModalNewCall.vue?vue&type=template&id=a4e1179a&scoped=true"
import script from "./ModalNewCall.vue?vue&type=script&lang=js"
export * from "./ModalNewCall.vue?vue&type=script&lang=js"
import style0 from "./ModalNewCall.vue?vue&type=style&index=0&id=a4e1179a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e1179a",
  null
  
)

export default component.exports